import { User } from 'lucide-react';
import clsx from 'clsx';

interface UserBadgeProps {
  username?: string | null;
  className?: string;
  showIcon?: boolean;
  size?: 'sm' | 'md';
}

/**
 * Component to display a username badge like "@username"
 */
export default function UserBadge({
  username,
  className,
  showIcon = true,
  size = 'sm',
}: UserBadgeProps) {
  if (!username) return null;

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 text-gray-500 dark:text-gray-400',
        size === 'sm' && 'text-xs',
        size === 'md' && 'text-sm',
        className
      )}
      title={`Создал: ${username}`}
    >
      {showIcon && (
        <User
          className={clsx(
            'flex-shrink-0',
            size === 'sm' && 'h-3 w-3',
            size === 'md' && 'h-4 w-4'
          )}
        />
      )}
      <span className="truncate max-w-[120px]">@{username}</span>
    </span>
  );
}
